'use strict';

var Reflux = require('reflux'),
    Application = require('js/shared/models/application.js'),
    StoreActions = require('js/shared/actions/store-actions.js'),
    TagActions = require('js/shared/actions/tag-actions.js'),
    TeamActions = require('js/shared/actions/team-actions.js'),
    ApplicationActions = require('js/shared/actions/application-actions.js'),
    UploadActions = require('js/shared/actions/upload-actions.js'),
    UserActions = require('js/shared/actions/user-actions.js'),
    Questions = require('js/screens/form/questions.jsx'),
    utils = require('js/shared/utils/utils.js'),
    HACKATHONS = require('js/shared/utils/events.js'),
    _ = require('underscore');

var STAGES = require('js/shared/utils/application-stages.js');

module.exports = Reflux.createStore({

    endpoint: '/v1/application',

    init: function() {
        this.application = Application.create({
            stage: STAGES.APPLICATION,
            page: 0,
            maxPageCompleted: 0
        });


        var rsvpPage = window.location.pathname.split("/")[1].split(".")[0] === "application";
        var token = utils.getParameterByName('token');

        // prevents loading user and claim on application submission page
        if (rsvpPage && token !== "") {
            this.isLoaded = false;
            this.loading = true;
            this.application.token = token;
        }
        else {
            this.isLoaded = true;
        }

        if (rsvpPage) {
            this.application.stage = STAGES.REVIEW;
        }

        window.app = this.application;

        this.application.saving = false;
        this.application.currentlyHasError = false;
        this.application.submitError = null;
        this.application.travelLoading = false;
        this.application.voteSubmitLoading = false;
        this.application.voteActive = false;
        this.application.no_claim_found = false;
        this.application.filesUploading = [];

        this.listenTo(ApplicationActions.submitError, this.onSubmitError);

        this.listenTo(TagActions.tagTextChange, this.onTagTextChange);

        this.listenTo(StoreActions.loadApplication.completed, this.onLoadApplicationCompleted);
        this.listenTo(StoreActions.loadApplication.failed, this.onLoadApplicationFail);
        this.listenTo(StoreActions.__loadUser.completed, this.onLoadUser);
        this.listenTo(StoreActions.__loadUser.failed, this.onLoadUserFail);
        this.listenTo(StoreActions.__loadClaim.completed, this.onLoadClaim);
        this.listenTo(StoreActions.__loadClaim.failed, this.onLoadClaimFail);

        this.listenTo(StoreActions.loadApplication, this.onLoadApplicationStarted);
        this.listenTo(UserActions.loadApplication, this.onLoadApplicationStarted);

        this.listenTo(UserActions.loadApplication.completed, this.onLoadApplicationCompleted);
        this.listenTo(UserActions.loadApplication.failed, this.onLoadApplicationFail);

        this.listenTo(TeamActions.createTeam.completed, this.onCreateTeam);
        this.listenTo(TeamActions.joinTeam.completed, this.onJoinTeam);

        this.listenTo(ApplicationActions.submitEdit, this.onSubmitEditStarted);
        this.listenTo(ApplicationActions.submitEdit.failed, this.onSubmitEditFailed);
        this.listenTo(ApplicationActions.submitEdit.completed, this.onSubmitEditCompleted);
        this.listenTo(ApplicationActions.updateField, this.onUpdateField);
        this.listenTo(ApplicationActions.nextQuestionPage, this.onNextQuestionPage);
        this.listenTo(ApplicationActions.changeQuestionPage, this.onChangeQuestionPage);
        this.listenTo(ApplicationActions.changeStage, this.onChangeStage);
        this.listenTo(ApplicationActions.completeForm, this.onCompleteForm);
        this.listenTo(ApplicationActions.createNewSchool, this.onCreateNewSchoolBefore);
        this.listenTo(ApplicationActions.withdrawApplication, this.onWithdraw);

        this.listenTo(ApplicationActions.createNewSchool.completed, this.onCreateNewSchoolCompleted);
        this.listenTo(ApplicationActions.setInitialValues, this.onSetInitialValues);
        this.listenTo(ApplicationActions.refreshApplication, this.onRefreshApplication);
        this.listenTo(ApplicationActions.__createUser.completed, this.onCreateUser);
        this.listenTo(ApplicationActions.__authUser.completed, this.onAuthUser);
        this.listenTo(ApplicationActions.__createClaim.completed, this.onCreateClaim);
        this.listenTo(ApplicationActions.submitApplication.completed, this.onSubmitApplicationSuccess);
        this.listenTo(ApplicationActions.submitApplication.failed, this.onSubmitApplicationFailed);
        this.listenTo(ApplicationActions.submitApplication, this.onSubmitApplicationStart);

        this.listenTo(ApplicationActions.submitTravelPage, this.onSubmitTravelPage);
        this.listenTo(ApplicationActions.submitTravelPage.completed, this.onSubmitTravelPageCompleted);

        this.listenTo(ApplicationActions.submitVotePage, this.onSubmitVotePage);
        this.listenTo(ApplicationActions.submitVotePage.completed, this.onSubmitVotePageCompleted);
        this.listenTo(ApplicationActions.viewVotePage, this.onViewVotePage);

        this.listenTo(UserActions.__authUser.completed, this.onUserAuthCompleted);

        this.listenTo(UploadActions.uploadFile.failed, this.onUploadFileFailed);
        this.listenTo(UploadActions.uploadFile, this.onUploadFile);
        this.listenTo(UploadActions.uploadFile.completed, this.onUploadFileCompleted);
    },


    getState: function() {
        return {
            dataIsLoaded: this.isLoaded,
            application: this.application,
            loading: this.loading,
        };
    },

    onSubmitTravelPage: function() {
        this.application.travelLoading = true;
        this.trigger('onSubmitTravelPage');
    },

    onSubmitTravelPageCompleted: function() {
        this.application.travelLoading = false;
        this.trigger('onSubmitTravelPageCompleted');
    },

    onSubmitVotePage: function() {
        this.application.voteSubmitLoading = true;
        this.trigger('onSubmitVotePage');
    },

    onSubmitVotePageCompleted: function() {
        this.application.voteSubmitLoading = false;
        window.scrollTo(0,100);
        this.application.voteActive = false;
        this.trigger('onSubmitVotePageCompleted');
    },

    onViewVotePage: function() {
        this.application.voteActive = true;
        this.trigger('onViewVotePage');
    },

    onUserAuthCompleted: function(resp) {
        this.application.token = resp.body.token;
        this.trigger('onUserAuthCompleted');
    },

    onTagTextChange: function(options) {
        this.application.tagTextInput[options.fieldName] = options.textInput;
        this.trigger('onTagTextChange');
    },

    onCreateTeam: function() {
        this.application.values.team_disclaimer = false;
        this.trigger('onCreateTeam');
    },
    onJoinTeam: function() {
        this.application.values.team_disclaimer = false;
        this.trigger('onJoinTeam');
    },

    onSubmitError: function() {
        this.application.currentlyHasError = true;
        this.trigger('submitError');
    },

    onLoadUser: function(resp) {},

    onLoadClaim: function(resp) {},

    onUploadFile: function(options) {
        this.application.filesUploading.push({
            fieldName: options.fieldName,
            fileName: options.file.name,
            id: options.id,
        });
        this.trigger('onUploadFile');
    },

    onUploadFileCompleted: function(resp_options) {
        var resp = resp_options[0];
        var options = resp_options[1];
        if (options.allowed_multiple) {
            if (this.application.values[options.fieldName] === undefined) {
                this.application.values[options.fieldName] = [];
            }
            this.application.values[options.fieldName].push(resp.body);
        }
        else {
            this.application.values[options.fieldName] = resp.body;
        }


        this.application.filesUploading = _.reject(this.application.filesUploading, function(upload) {
            return upload.id === options.id;
        });
        this.trigger('onUploadFileCompleted');
    },

    onUploadFileFailed: function(resp_options) {
        var error = resp_options[0];
        var options = resp_options[1];
        this.application.filesUploading = _.reject(this.application.filesUploading, function(upload) {
            return upload.id === options.id;
        });
        console.warn("Uploading file failed", error, error.body, options);
        this.trigger('onUploadFileFailed');
    },

    onSubmitEditFailed: function(values) {
        this.application.saving = false;
        if (typeof Bugsnag !== 'undefined') {
            // Expection Name, Exception Description, metadata, severity
            // put any valid JSON into metadata to get as much information as possible for debugging
            Bugsnag.notify("SubmitEditPromiseError", "Submitting an application edit failed", values, "error");
        }
        if (Array.isArray(values) && values[values.length - 1].body && values[values.length - 1].body.success === false ) {
            this.application.submitError = values[values.length - 1].body.message;
        }
        else {
            this.application.submitError = "There was an error while trying to save your application. If this problem persist please contact hello@hackthenorth.com";
        }
        this.trigger('submitFailed');
    },

    onSubmitEditStarted: function(values) {
        this.application.saving = true;
        this.trigger('submitStarted');
    },

    onSubmitEditCompleted: function(values) {
        this.application.saving = false;
        this.application.submitError = null;
        this.application.no_claim_found = false;

        this.trigger('submitCompleted');
    },

    onSetInitialValues: function(values) {
        var $this = this;
        _(values).forEach(function(value, key) {
            $this.application.setField(key, value);
        });
    },

    onLoadApplicationStarted: function() {
        this.loading = true;

        this.trigger('loadingApplicationStarted');
    },

    onLoadApplicationCompleted: function(resps) {
        this.loading = false;
        var user_resp = resps[0].body;
        var claim_resp;
        if (resps[1].body.length === 0) {
            if (typeof Bugsnag !== 'undefined') {
                Bugsnag.notify("NoClaimFoundError", "Accessing application, no claim found :(", resps[0], "error");
            }
            claim_resp = {
                fields: {}
            };
            this.application.no_claim_found = true;
        }
        else {
            claim_resp = resps[1].body[0];
        }


        var team_resp = resps[2].body[0];

        this.user = user_resp;

        this.application.claim_id = claim_resp.id;
        this.application.user_id = user_resp.id;
        this.application.claim = claim_resp;
        this.application.user = user_resp;

        var claimIdToFieldNameMapping = {
            '1': "graduating_year",
            '2': "first_hackathon",
            '3': "proud_project", // proud_project (not used, cool_story_bro is)
            '4': "birthday",
            '5': "resume",
            '6': "interests", // not
            '1342': "travel_reimbursements",
            '1343': "cool_story_bro",
            '1344': "age",
            '1345': "academic_program",
            '1346': "has_idea",
            '1347': "hardware_hack",
            '1348': "did_attend_htn",
            '1349': "team_disclaimer",

            "1358": "opt_out",
            "1359": "resume_internship",
            "1360": "resume_companies",
            "1363": "resume_file",
            "1362": "waiver_youth",
            "1364": "additional_food_other",
            "1361": "additional_hardware",
            "1366": "waiver_legal_name",
            "1367": "waiver_parental_name",
            "1368": "waiver_parental_email",
            "1370": "waiver_emerg_email",
            "1371": "waiver_phone",
            "1372": "waiver_emerg_relationship",

            '1365': "age2",
            "1374": "confirmed",
            '1377': "travel_type",
            '1376': "travel_receipts",
            '1378': "travel_flying_code",
            '1379': "travel_arrival_time",
            '1380': "travel_departure_time",
            '1382': "travel_bus_route",
            '1383': "travel_border",
            '1384': "travel_disclaimers",
            '1385': "travel_passport_type",

            '1393': "application_edit",

            '1394': "votepage_votes",
            '1395': "votepage_hardware",
            '1396': "votepage_learn",
        };


        _.forEach(claim_resp.fields, function(val, field) {
            var fieldName = claimIdToFieldNameMapping[field];
            if (fieldName) {
                this.application.values[fieldName] = val;
            }
        }.bind(this));

        // cast travel type enum (hackerapi) to travel.js enum


        var ttype = _.invert({'0': "walking",
                     '1': "flying",
                     '2': "bus",
                     '3': "driving",
                     '4': "public_transit"});
        this.application.values.travel_type = ttype[this.application.values.travel_type];

        // need a better way to cast bool to Yes/No
        _.forEach(['first_hackathon', 'has_idea', 'hardware_hack', 'travel_reimbursements', 'age', "did_attend_htn", "resume_internship", "travel_border", "age2"], function(fieldName) {
            if (this.application.values[fieldName] === null || this.application.values[fieldName] === undefined) {
                this.application.values[fieldName] = null;
            } else {
                this.application.values[fieldName] = this.application.values[fieldName] ? "Yes" : "No";
            }
        }.bind(this));

        if(claim_resp.fields['1349']) {
            this.application.values.team_disclaimer = "I understand that I will be considered individually and not as a team";
        }

        // de JSONify some data saved as text
        _.each(['resume_file', 'waiver_youth', 'travel_receipts', 'travel_disclaimers'], function(fieldName) {
            if (this.application.values[fieldName] !== undefined) {
                this.application.values[fieldName] = JSON.parse(this.application.values[fieldName]);
            }
        }.bind(this));

        if (this.application.values.votepage_votes === undefined) {
            this.application.values.votepage_votes = [];
        }

        this.application.values.additional_food_restrictions = user_resp.food_restrictions;
        this.application.values.additional_shirt = user_resp.shirt_size;
        this.application.values.skills = user_resp.interests; // :( bad naming
        this.application.values.name = user_resp.full_name;
        this.application.values.email = user_resp.email;
        this.application.values.school_email = user_resp.school_email;
        this.application.values.gender = user_resp.demographics.gender;
        this.application.values.current_city = user_resp.travel.current_city;
        this.application.values.institution = user_resp.education.institution_id;
        this.application.values.current_status = user_resp.education.current_status;

        this.application.values.reimbursement_address_line1 = user_resp.shipping_address.line_1;
        this.application.values.reimbursement_address_line2 = user_resp.shipping_address.line_2;
        this.application.values.cheque_name = user_resp.shipping_address.line_3;
        this.application.values.reimbursement_address_city = user_resp.shipping_address.city;
        this.application.values.reimbursement_address_state = user_resp.shipping_address.state_province;
        this.application.values.reimbursement_address_zipcode = user_resp.shipping_address.zip_postal_code;
        this.application.values.reimbursement_address_country = user_resp.shipping_address.country;



        try {
            this.application.values.academic_year = parseInt(user_resp.education.graduating_year);
        } catch (e) {

        }
        this.application.values.academic_program = user_resp.education.program;
        this.application.values.portfolio = user_resp.url.portfolio;
        this.application.values.github = user_resp.url.github;
        this.application.values.linkedin = user_resp.url.linkedin;
        this.application.values.hackathons = _.map(user_resp.hackathons, function(hackathon) {
            var fullForm = HACKATHONS.slugToHackathonMapping[hackathon];
            if (fullForm === undefined) {
                return hackathon;
            }
            else {
                return fullForm;
            }
        });

        var revertDate = function(inp) {
          if (inp === '' || !inp) {
            return '';
          }
          var ndate = '';
          var s = inp.split('-');
          var y = s[0];
          var m = s[1];
          var d = s[2];

          if(d[0] === '0') {
             d = d[1];
          }

          return d+'/'+m+'/'+y;
        };

        this.application.values.waiver_address_line1 = user_resp.address.line_1;
        this.application.values.waiver_address_line2 = user_resp.address.line_2;
        this.application.values.waiver_address_state = user_resp.address.state_province;
        this.application.values.waiver_address_city = user_resp.address.city;
        this.application.values.waiver_address_country = user_resp.address.country;
        this.application.values.waiver_address_zipcode = user_resp.address.zip_postal_code;
        this.application.values.waiver_emerg_phone = user_resp.emergency_contact.phone_number;
        this.application.values.waiver_emerg_name = user_resp.emergency_contact.full_name;
        this.application.values.waiver_dob = revertDate(user_resp.demographics.date_of_birth);
        this.application.values.travel_passport_expiry = revertDate(user_resp.travel.expiry_date);
        this.application.values.travel_passport_country = user_resp.travel.visa_country;
        this.application.values.travel_passport_visa_type = user_resp.travel.visa_type;

        this.isLoaded = true;

        this.application.claim_stage = claim_resp.stage;

        this.trigger('loadApplication');
    },

    onLoadUserFail: function(resp) {
        // this.trigger('loadUserFail');
    },

    onLoadClaimFail: function(resp) {
        // this.trigger('loadClaimFail');
    },

    onLoadApplicationFail: function(resp) {
        this.loading = false;
        console.log('Login failed');

        this.trigger('loadApplicationFail');
    },

    onRefreshApplication: function(resp) {
        // this.application.values = resp.body;
    },

    onCreateUser: function(resp) {
        console.log('onCreateUser triggered');
    },

    onAuthUser: function(resp) {
        console.log('onAuthUser triggered');
    },

    onCreateClaim: function(resp) {
        console.log('onCreateClaim triggered');
    },

    onSubmitApplicationSuccess: function(resp) {
        this.application.stage = STAGES.SUBMITTED;
        this.application.submitting = false;
        console.log('onSubmitApplicationSuccess triggered');
        this.trigger('onSubmitApplicationSuccess');
    },

    onSubmitApplicationStart: function() {
        this.application.submitting = true;
        this.trigger('onSubmitApplicationStart');
    },

    onSubmitApplicationFailed: function(resp) {
        this.application.submitting = false;
        if (resp && resp.body && resp.body.success === false) {
            alert(resp.body.message);
        }
        else {
            alert('There was an error submitting your application. If this problem persists please contact hello@hackthenorth.com');
        }
        this.trigger('onSubmitApplicationFailed');
    },

    onNextQuestionPage: function() {
        // Don't continue if errors exist
        var fieldName = Questions[this.application.page].fieldName;

        if (!this.application.getError(fieldName)) {
            this.application.page = this.application.page + 1;
            this.application.maxPageCompleted = Math.max(
                this.application.page,
                this.application.maxPageCompleted);
        }
        this.trigger('nextQuestionPage');
    },

    onChangeQuestionPage: function(pageNum) {
        // Don't continue if errors exist
        if (pageNum <= this.application.maxPageCompleted) {
            this.application.page = pageNum;
        }
        this.trigger('changeQuestionPage');
    },

    onUpdateField: function(fieldName, value) {
        this.application.setField(fieldName, value);
        this.application.currentlyHasError = false;
        this.trigger('updateField');
    },

    onCreateNewSchoolBefore: function() {
        this.application.setField("institution", "submitted");
        if (this.application.stage === STAGES.APPLICATION) {
            this.application.page = this.application.page + 1;
        }
        this.trigger('onCreateNewSchoolBefore');
    },

    onCreateNewSchoolCompleted: function(resp) {
        this.application.setField("institution", resp.body.id);
        this.trigger('updateField');
    },

    onChangeStage: function(toStage) {
        this.application.stage = toStage;
        this.trigger('changeStage');
    },

    onCompleteForm: function() {
        var fieldName = Questions[this.application.page].fieldName;
        if (!this.application.getError(fieldName)) {
            this.application.stage = STAGES.COMPLETED;
        } else {
            this.application.errors[fieldName] = true;
        }
        this.trigger('completeForm');
    },

    onWithdraw: function () {
        this.application.claim.fields[1381] = true;
        this.trigger('onWithdraw');
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/stores/application-store.js
 ** module id = 256
 ** module chunks = 0 1
 **/